export default {
    failedToSendMessage: 'Не удалось отправить\nсообщение',
};
